
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"24","viewBox":"0 -960 960 960","width":"24","fill":"#5f6368"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M40-120l440-760 440 760H40zm138-80h604L480-720 178-200zm302-40q17 0 28.5-11.5T520-280q0-17-11.5-28.5T480-320q-17 0-28.5 11.5T440-280q0 17 11.5 28.5T480-240zm-40-120h80v-200h-80v200zm40-100z"}})])
          )
        }
      }
    